import {BenefitTag} from '@bonprix/design-system';
import React, {useEffect, useState} from 'react';
import ProductChangedEvents from '../../events/product-changed-events';
import Device from '@core/scripts/components/device';
import TrinityHelper from "@product/helper/trinity/trinity.js";

export default function Benefits({product}) {
    const [benefits, setBenefits] = useState(product.currentItem?.benefits || []);

    ProductChangedEvents.onItemChange((item) => {
        setBenefits(item?.benefits || []);
    });

    useEffect(() => {
        const isVeryPopular = benefits?.some(b => b.name?.toLowerCase() === "sehr beliebt");
        if (isVeryPopular) {
            TrinityHelper.sendViewLabelVerypopular();
        }
    }, [benefits]);

    const displaySize = (Device.isTouch() || Device.isApp()) ? "small" : "large";

    if (benefits.length > 0) {
        return (
            <>
                {benefits.map((benefit, index) => {
                        return (<div key={index} className="product__benefit">
                            <BenefitTag variant={benefit.displayType.toLowerCase()} size={displaySize}>{benefit.name}</BenefitTag>
                        </div>);
                    }
                )}
            </>);
    }
    return <></>;
}